export const CASES = {
    UPDATE_CLEARANCE_MEMO_TITLES: 'UPDATE_CLEARANCE_MEMO_TITLES',
    UPDATE_CLEARANCE_MEMO_TITLES_FILTER_FORM: 'UPDATE_CLEARANCE_MEMO_TITLES_FILTER_FORM',
    CLEAR_CLEARANCE_MEMO_TITLES: 'CLEAR_CLEARANCE_MEMO_TITLES',
};
